import { useCurrentUserData } from '~/root/Auth';
import { MedlyNavButton } from '~/root/Medly';
import { useNavigation } from '../../context';
import { NavigationLink } from '../../NavigationLink';
import { NavigationSection } from '../../NavigationSection';
import { SubNavigation } from '../../SubNavigation';
import { CreditsBanner, EnterpriseBanner, TenHourTurnaroundBanner } from '../banners';
import { config } from '../config';

export const ManagerNavigation = () => {
  const { isMenuCollapsed, isFromHeader } = useNavigation();
  const { hasDailyCapacity, purchasedPackages, subscription, customerRole, marketingCampaigns } =
    useCurrentUserData();

  const showTenHourTurnaroundBanner = marketingCampaigns?.tenHoursTurnaround;
  const showEnterpriseBanner = !isMenuCollapsed && !isFromHeader && subscription;
  const showCreditsBanner = !hasDailyCapacity && purchasedPackages && customerRole === 'admin';

  const showBannerContainer =
    showCreditsBanner || showEnterpriseBanner || showTenHourTurnaroundBanner;

  return (
    <>
      <NavigationSection>
        <NavigationLink {...config.links.myOrders} />
        <NavigationLink {...config.links.myTeam} />
        <NavigationLink {...config.links.holidayCalendar} />
        <NavigationLink {...config.links.capacityOverview} />
        <SubNavigation {...config.subMenus.settings}>
          <NavigationLink {...config.links.userDetails} />
          <NavigationLink {...config.links.security} />
        </SubNavigation>
        <NavigationLink {...config.links.needHelp} />
      </NavigationSection>

      <MedlyNavButton />

      {showBannerContainer && (
        <div className="lg:mx-0 mx-2 lg:space-y-2 space-y-3">
          {showCreditsBanner && <CreditsBanner />}
          {showEnterpriseBanner && <EnterpriseBanner />}
          {showTenHourTurnaroundBanner && <TenHourTurnaroundBanner />}
        </div>
      )}
    </>
  );
};
